// extracted by mini-css-extract-plugin
export default {"container":"style_container__SSYhI","relative":"style_relative__aV9F0"};